import React, { Component } from 'react';
import { Grid, Button, Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../../constants/translation';

class SelectList extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    filterName: PropTypes.string.isRequired,
    hasSearch: PropTypes.bool,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onFocus: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultProps = {
    hasSearch: false,
    options: [],
    placeholder: 'Select an Option',
    value: '',
    onFocus: false,
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    const onFocus = props.onFocus;
    return {
      value,
      onFocus,
    };
  }
  constructor(props) {
    super(props);
    const state = SelectList.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = SelectList.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, { value }) => {
    this.setState({
      value,
      onFocus: false,
    }, () => {
      this.props.onChange(value, this.props.filterName);
    });
  }
  handleClose = () => {
    this.setState({
      value: '',
    }, () => {
      this.props.onClose(this.props.filterName);
    });
  }
  handleOnFocusChange = () => {
    this.setState({ onFocus: !this.state.onFocus });
  }
  render() {
    const { t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={14}>
                  <Dropdown
                    disabled={this.props.disabled}
                    fluid
                    header={this.props.headerText && this.props.headerText}
                    onChange={this.handleOnChange}
                    options={this.props.options}
                    placeholder={this.props.placeholder}
                    search={this.props.hasSearch}
                    selection
                    selectOnBlur={false}
                    value={this.state.value}
                    open={this.state.onFocus}
                    onClick={this.handleOnFocusChange}
                    noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                  />
                </Grid.Column>
                {
                this.props.value.length > 0 &&
                  <Grid.Column width={2} verticalAlign="middle" className="clearicon">
                    <Button
                      as="a"
                      circular
                      icon="x"
                      onClick={this.handleClose}
                      size="mini"
                      title="Clear"
                    />
                  </Grid.Column>
                }
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation([TRANSLATION_FILES.translation], { withRef: true })(SelectList);



// WEBPACK FOOTER //
// ./src/components/Filters/SelectList.jsx